import e,{css as t}from"../../../node_modules/styled-components/dist/styled-components.esm.js";import{StyledButtonBase as o}from"./ButtonBase.styled.js";import{defaultTheme as r}from"../../../theme/index.js";const i=r["theme"],n=i["colorVariables"],d=e(o)`
  background: ${e=>e.alternative?n.bgPrimary:"transparent"};
  color: ${n.textAccent};
  border: 1px solid ${n.borderBlueLight};

  &:not([disabled]):hover {
    background-color: ${e=>e.alternative?n.textAccent:n.selectedItem};
    color: ${e=>e.alternative?n.textLight:n.textAccent};
  }

  &:before {
    display: none;
    background-color: ${n.selectedItem};
  }

  &[disabled] {
    color: ${n.borderPrimary};
    background: ${n.bgPrimary};
    border: 1px solid ${n.borderPrimary};
    cursor: default;
    pointer-events: none;
  }

  &[disabled]:hover {
    background: ${n.bgPrimary};
  }

  &:not([disabled]):active {
    box-shadow: 0 0 0 2px rgba(61, 149, 251, 0.5);
  }

  ${({size:e,alternative:o})=>"small"===e?t`
          ${i.mixin.fontButtonS}
          padding: 8px 16px;
          height: 32px;

          > svg {
            width: 16px;
            height: 16px;
          }
        `:t`
          ${o?i.mixin.fontButtonM:i.mixin.fontButtonS}
          padding: 10px 20px;
          height: 40px;

          > svg {
            width: 20px;
            height: 20px;
          }
        `}
`;export{d as StyledButtonOutline};
